import Mock from 'mockjs'
// 商品列表
import MOCK030001 from './getProductList'
// 商品详情
import MOCK030002 from './getProductDetail'
// 收货地址
import MOCK030004 from './getAddressList'
// 供应商上架列表
import MOCK030010 from './getVendorProductOnline'
// 供应商下架列表
import MOCK030009 from './getVendorProductOffline'
// 商品信息初始化
import MOCK030003 from './getInitProductInfo'
// 订单列表
import MOCK050020 from './getOrderList'
// 订单详情
import MOCK050021 from './getOrderDetail'
// 要货单列表
import MOCK050022 from './getRequireOrderList'
// 要货单详情
import MOCK050023 from './getRequireOrderDetail'

const data = Mock.mock({
  // 属性 list 的值是一个数组，其中含有 1 到 10 个元素
  'productList|0-10': [{
    'name': "@ctitle(2,10)",
    "img": "@image('600x600',#b7ef7c)",
    "brief": "@csentence(1,50)",
    "price|0-20.0-2": 1,
    "num": 0,
    "minusFlag": true,
    "time": "@time",
    "peisongfei|0-100.0-2": 1,
    "limit|0-50": 1
  }],
  "productDetail": {
    'name': "@ctitle(2,10)",
    "img": "@image('600x600',#b7ef7c)",
    "brief": "@csentence(1,50)",
    "price|0-100.0-2": 1,
    "num": 0,
    "minusFlag": true,
    "time": "@time",
    "peisongfei|0-100.0-2": 1,
    "limit|0-100": 1
  }
});

export default {
  data,
  MOCK030001,
  MOCK030004,
  MOCK030002,
  MOCK030010,
  MOCK030009,
  MOCK030003,
  MOCK050020,
  MOCK050021,
  MOCK050022,
  MOCK050023
}


// WEBPACK FOOTER //
// ./src/mock/mock.js